import { useItem } from "../../../fetch/fetch.item";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item";
import ErrMessage from "../../core/ErrMessage";
import { useContext } from "react";
import { postChat } from "../../../fetch/fetch.chat";
import { useNavigate } from "react-router-dom";
import PopUp, { openModal } from "../../core/PopUp";
import MessageForm, { MessageFormType } from "../../messages/form/MessageForm";
import { SubmitHandler } from "react-hook-form";
import { MessagePostType } from "../../../types/Message";
import { sendMessage } from "../../../fetch/fetch.message";
import { MESSAGE_URL } from "../../../fetch/const.routes";
import { SubmitContext } from "../../../context/context.submit";
import { useSWRConfig } from "swr";
import ItemTitle from "../../item/core/ItemTitle";
import UserTitle from "../../user/core/UserTitle";
import ItemImage from "../../item/core/ItemImage";
import ItemFetch from "../../item/fetch/ItemFetch";
import { ROUTE_CHAT } from "../../../const/routes";
import { useAuthToken } from "../../../hooks/useAuthToken";
import { IconInfoCircle, IconMessageCirclePlus } from "@tabler/icons-react";
import Alert from "../../core/Alert.tsx";

const CreateChat = ({
  itemId,
  children,
  fallback,
}: {
  itemId: string;
  children: (handleClick: () => void) => React.ReactNode;
  fallback: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const { setError } = useContext(SubmitContext);
  const { mutate } = useSWRConfig();

  const authToken = useAuthToken();
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);

  if (isError) return <ErrMessage message={isError} />;

  if (
    authToken.status === "loading" ||
    isLoading ||
    authToken.status === "error"
  )
    return fallback;
  //show no chat icon when the item is of the owner
  if (item.ownerId === authToken.authId) return null;

  const handleSubmit: SubmitHandler<MessageFormType> = async (data) => {
    const chat = await postChat(itemId);
    if (!chat.ok) {
      setError(chat.error);
      return;
    }
    const chatId = chat.value._id;
    const message: MessagePostType = {
      content: data.chatMessage,
      chatId: chatId,
    };
    const res = await sendMessage(chatId, message);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    await mutate(MESSAGE_URL + chatId);
    navigate(ROUTE_CHAT(chatId));
  };
  return (
    <>
      <PopUp
        id={"contact"}
        title={
          <>
            <IconMessageCirclePlus />
            Nachricht schreiben
          </>
        }
      >
        <div className="flex flex-col gap-2">
          <Alert
            icon={<IconInfoCircle />}
            text="Nachrichten werden aus Datenschutzgründen nach 30 Tagen gelöscht.
Der Chat ist nicht Ende-zu-Ende verschlüsselt. Es besteht die Möglichkeit, dass Inhalte von berechtigten Stellen eingesehen werden.
Bitte teile keine sensiblen Informationen und beachte, dass andere Nutzer nicht immer vertrauenswürdig sind. "
          />
          <div className="flex justify-between bg-base-300 items-center px-2 h-16 rounded-box grow overflow-hidden">
            <div className="flex flex-col w-fit max-w-full truncate">
              <ItemTitle id={itemId} />
              <div className="text-xs uppercase font-semibold opacity-60">
                <ItemFetch fallback={"Loading..."} id={itemId}>
                  {(item) => <UserTitle userId={item.ownerId} />}
                </ItemFetch>
              </div>
            </div>
            <ItemImage className="size-18 rounded-full" id={itemId} />
          </div>

          <MessageForm
            onSubmit={handleSubmit}
            placeholder="Schreibe eine nette Nachricht..."
          />
        </div>
      </PopUp>
      {children(() => openModal("contact"))}
    </>
  );
};
export default CreateChat;
